import React, {createContext, useContext, useReducer} from "react";

const MuseumFilterStateContext = createContext(undefined);
const MuseumFilterDispatchContext = createContext(undefined);

export const CHECK = 'check';
export const UNCHECK = 'uncheck';
export const OPEN = 'open';
export const CLOSE = 'close';
export const SET_MUSEUMS = 'setMuseums';
export const SET_PARENTS = 'setParents';
export const INCLUDE_MUSEUM_IDS = 'includeMuseumIds';
export const CHECK_ALL = 'checkAll';
export const UNCHECK_ALL = 'uncheckAll';
export const SET_CHECKED = 'setChecked';
export const COLLAPSED = 'collapsed'
export const EXPANDED = 'expanded'

const initialState = {
    museums: [],
    excludeIds: [],
    includeIds: [],
    checked: [],
    open: false,
    parents: [],
    filterLabel: '',
    yourMuseumsLabel: '',
    expanded: false
}

const museumFilterReducer = (state, action) => {
    console.debug(action)
    switch(action.type) {
        case SET_CHECKED:
            return {
                ...state,
                checked: action.checked
            }
        case CHECK:
            return {
                ...state,
                checked: [...state.checked, action.id]
            }
        case UNCHECK:
            return {
                ...state,
                checked: state.checked.filter(c => c !== action.id)
            }
        case OPEN:
            return {
                ...state,
                open: true
            }
        case CLOSE:
            return {
                ...state,
                open: false
            }
        case SET_MUSEUMS:
            return {
                ...state,
                museums: action.museums
            }
        case SET_PARENTS:
            return {
                ...state,
                parents: action.parents
            }
        case INCLUDE_MUSEUM_IDS:
            return {
                ...state,
                includeIds: action.ids,
                checked: action.ids
            }
        case CHECK_ALL:
            return {
                ...state,
                checked: state.includeIds
            }
        case UNCHECK_ALL:
            return {
                ...state,
                checked: []
            }
        case COLLAPSED:
            return {
                ...state,
                expanded: false
            }
        case EXPANDED:
            return {
                ...state,
                expanded: true
            }

        default:
            throw new Error(`Unknown action type ${action.type}`)
    }
}

export const MuseumFilterProvider = ({yourMuseumsLabel='Dine museer', filterLabel='Filtrer', children}) => {
    const [state, dispatch] = useReducer(
        museumFilterReducer,
        {
            ...initialState,
            yourMuseumsLabel: yourMuseumsLabel,
            filterLabel: filterLabel
        },
        undefined
    );

    return (
        <MuseumFilterStateContext.Provider value={state}>
            <MuseumFilterDispatchContext.Provider value={dispatch}>
                {children}
            </MuseumFilterDispatchContext.Provider>
        </MuseumFilterStateContext.Provider>
    )
}

export const useMuseumFilterState = () => {
    const context = useContext(MuseumFilterStateContext);
    if(undefined === context) {
        throw new Error(`useMuseumFilterState must be used within an MuseumFilterProvider`);
    } else {
        return context;
    }
}

export const useMuseumFilterDispatch = () => {
    const context = useContext(MuseumFilterDispatchContext);
    if(undefined === context) {
        throw new Error(`useMuseumFilterDispatch must be used within an MuseumFilterProvider`);
    } else {
        return context;
    }
}